import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useQuizApi() {
    const api = useApi();
    const state = useAppState();
    function getQuizzes(onlyTodaysQuizzes, todaysQuestionsOnly, tomorrowsQuestionsOnly, onSuccess = null) {
        api.GET("/Quizzes?onlyTodaysQuizzes=" + onlyTodaysQuizzes + "&todaysQuestionsOnly=" + todaysQuestionsOnly + "&tomorrowsQuestionsOnly=" + tomorrowsQuestionsOnly, (result) => {
            state.quizzes = result;
            if (onSuccess)
                onSuccess();
        }, true);
    }
    function getQuizPoints(quizId, onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/Quizzes/" + quizId + "/Points", (result) => {
            state.quizPoints = result;
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function getQuizAnswers(quizId, onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/Quizzes/" + quizId + "/Answers", (result) => {
            state.quizAnswers = result;
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function clearQuizCache(quizId) {
        const quizCacheKey = getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Quizzes/" + quizId;
        localStorage.removeItem(quizCacheKey + "/Answers");
        localStorage.removeItem(quizCacheKey + "/Points");
    }
    function postQuizAnswer(quizId, questionId, answerId, onSuccess = null) {
        const requestBody = {
            "quizId": quizId,
            "customerId": "00000000-0000-0000-0000-000000000000",
            "questionId": questionId,
            "answerId": answerId
        };
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Quizzes/" + quizId + "/Answers", requestBody)
            .then((response) => {
            if (onSuccess)
                onSuccess(response.data);
        })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => postQuizAnswer(quizId, questionId, answerId, onSuccess));
            }
        });
    }
    function getQuestionnaireByGuidOrKey(id, onSuccess = null) {
        if (id.match(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/)) {
            getQuestionnaire(id, onSuccess);
        }
        else {
            getQuestionnaireByKey(id, (result) => {
                state.questionnaire = result;
                if (onSuccess)
                    onSuccess();
            });
        }
    }
    function getQuestionnaire(id, onSuccess = null) {
        api.GET("/Questionnaires/" + id, (result) => {
            state.questionnaire = result;
            if (onSuccess)
                onSuccess();
        }, true);
    }
    function getQuestionnaireByKey(key, onSuccess = null, onError = null) {
        getHttpInstance().post(getApiConfig().api + "/Questionnaires/Searches/" + key, null)
            .then((response) => {
            if (onSuccess)
                onSuccess(response.data);
        })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => getQuestionnaireByKey(key, onSuccess, onError));
            }
            else if (onError) {
                onError(result);
            }
        });
    }
    function getQuestionnaireAnswers(id, onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/CustomerAnswers", (result) => {
            state.questionnaireAnswers = result;
            if (onSuccess)
                onSuccess(result);
        }, false);
    }
    function saveQuestionnaireAnswer(question, onSuccess = null) {
        const requestBody = [];
        if (!question.question.selectedAnswer) {
            return;
        }
        question.question.selectedAnswer.forEach((selectedAnswer) => {
            const answer = {
                "questionID": question.questionId,
            };
            if (selectedAnswer.answerId) {
                answer.answerID = selectedAnswer.answerId;
            }
            if (selectedAnswer.amount != undefined && selectedAnswer.amount != null) {
                answer.freeAnswer = String(selectedAnswer.amount);
            }
            requestBody.push(answer);
        });
        if (requestBody.length == 0) {
            return;
        }
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/CustomerAnswers", requestBody)
            .then((result) => {
            if (onSuccess)
                onSuccess(result.data);
        })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => saveQuestionnaireAnswer(question, onSuccess));
            }
        });
    }
    return {
        getQuizzes,
        getQuizPoints,
        getQuizAnswers,
        clearQuizCache,
        postQuizAnswer,
        getQuestionnaire,
        getQuestionnaireByKey,
        getQuestionnaireByGuidOrKey,
        getQuestionnaireAnswers,
        saveQuestionnaireAnswer,
    };
}
